import { getDemoData, matchRestRequest } from '../utils'
import { DemoApiMock } from '../types'

export const mockGetPendingCalloutShifts: DemoApiMock = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      '/company/graphql_dispatch/shifts_with_callouts_9998eb4d',
      'POST'
    ),
  getResponse: async () => {
    const demoData = getDemoData()
    const shifts = demoData.shifts.filter((shift) =>
      (shift.work || []).some((work) =>
        (work.callouts || []).some((c) => c.status === 'requested')
      )
    )

    // Format the response to match the expected structure
    const formattedShifts = shifts.map((shift) => ({
      id: shift.id,
      startsAt: shift.startsAt,
      endsAt: shift.endsAt,
      assignment: shift.assignment,
      location: shift.location,
      position: shift.position,
      work: shift?.work
        ?.filter((work) => work.callouts?.some((c) => c.status === 'requested'))
        .map((work) => ({
          worker: work.worker,
          callouts: work.callouts,
        })),
    }))

    return { data: { company: { shifts: formattedShifts } } }
  },
}
